export const sliderSettings = {
  dots: false,
  nav: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1536,
      settings: {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "35px",
        slidesToShow: 3,
        speed: 500,
      }
    },
    {
      breakpoint: 1280,
      settings: {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "65px",
        slidesToShow: 2,
        speed: 500,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
};